import { render, staticRenderFns } from "./vendorAssessDetail.vue?vue&type=template&id=ddc0da24"
import script from "./vendorAssessDetail.vue?vue&type=script&lang=js"
export * from "./vendorAssessDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddc0da24')) {
      api.createRecord('ddc0da24', component.options)
    } else {
      api.reload('ddc0da24', component.options)
    }
    module.hot.accept("./vendorAssessDetail.vue?vue&type=template&id=ddc0da24", function () {
      api.rerender('ddc0da24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/csm/vendorAssessDetail.vue"
export default component.exports